import React, { useContext } from 'react'
import cn from 'classnames'

import { SvgResource } from 'components'
import { Context } from '../Context'
import style from './CustomSelectField.module.css'

export type CustomSelectFieldType = {
    classes?: string
    classesArrowSvg?: string
    showArrow?: boolean
    arrowWidth?: number
    arrowHeight?: number
    title?: string
    disabled?: boolean
    onClick?: () => void
}

const CustomSelectField: React.FC<CustomSelectFieldType> = ({
    children,
    classes,
    classesArrowSvg,
    showArrow = true,
    arrowWidth = 16,
    arrowHeight = 14,
    title,
    disabled,
    onClick = () => {},
}) => {
    const { isOpen, setOpen } = useContext(Context)

    const handlerClick = () => {
        if (!disabled) {
            setOpen(!isOpen)
            onClick()
        }
    }

    return (
        <div
            className={cn(style.field, classes, { [style.disabled]: disabled })}
            role="button"
            tabIndex={0}
            onKeyDown={() => {}}
            onClick={handlerClick}
        >
            <div className={style.fieldRow} title={title}>
                {children}
            </div>
            {showArrow && !disabled && (
                <SvgResource
                    classes={cn(style.fieldArrow, classesArrowSvg, { [style.fieldArrow_open]: isOpen })}
                    resourceKey="dropdpwn_daw_svg"
                    isImgTag={false}
                    width={arrowWidth}
                    height={arrowHeight}
                />
            )}
        </div>
    )
}

export default CustomSelectField
